<template>
    <div>
        <div class="container card" :style="'background-color: ' + cardBackground">
        <!-- <img src="images/meditation.png"  class="watemark"> -->
            <div class="background">
            <div class="Circle1" :style="'background-color: ' + cardCircle1"></div>
            <div class="Circle2" :style="'background-color: ' + cardCircle2"></div>
            <div class="Circle3" :style="'background-color: ' + cardCircle3"></div>
            <div class="content">
                <span class="logo">
                    <img :src="imgAvatar" width="60px">
                </span>
                <span class="brand">{{brandName}}</span>
                <p class="addr" id="addr" v-html="fancyAddress"></p>
                <p class="name" id="name"></p>
                <p class="amount">
                <span><input id="amount" type="number" v-model="amount" min="0.01" step="0.01"></span>
                <span class="currency"><strong>ETH</strong></span>
                </p>
                <span class="balance" id="balance">Balance: {{balance}} E</span>
                <span v-if="balance !== ''" class="all-balance" @click="allBalance()">All</span>
                <h1 class="network" 
                    id="network" 
                    :style="'background-color: ' + backgroundNetwork">{{networkName}}</h1>
                <h1 class="pay">
                    <button class="tip-button" @click="donation()"></button>
                </h1>
            </div>
        </div>
        </div>
        <div>
            <span v-html="message" ></span>
        </div>
    </div>
</template>
<script>

export default {
    name: 'cashCard',
    props: [
        'payAddress', 
        'networkName', 
        'brandName', 
        'balance', 
        'address', 
        'defaultAmount',
        'imgAvatar',
        'cardBackground',
        'cardCircle1',
        'cardCircle2',
        'cardCircle3',
        'backgroundNetwork',
        ],
    data() {
        return {
            fancyAddress: '',
            amount: this.defaultAmount,
            message: '',
            
        }
    },
    created: function() {
        if (this.payAddress) this.fancyAddress = this.makeFancyAddress(this.payAddress)
    },
    methods: {
        makeFancyAddress(inp) {
            let out = ""
            out = out +  inp.substr(0, 4) + " "
            out += inp.substr(4, 4) + " "
            out += inp.substr(8, 4) + " "
            out += inp.substr(12, 4) + " "
            out += inp.substr(16, 5)
            out += "<br/>"
            out += inp.substr(21, 4) + " "
            out += inp.substr(25, 4) + " "
            out += inp.substr(29, 4) + " "
            out += inp.substr(33, 4) + " "
            out += inp.substr(37, 5) 
            return out
        },
        donation() {
            const self = this
            if (typeof web3 !== 'undefined') {
                web3.eth.sendTransaction({
                to: this.payAddress,
                from: this.address,
                value: web3.toWei(Number(this.amount), 'ether'),
                //    data: web3.toHex('Donation for a good Karma!')
                }, function (err, transactionHash) {
                    if (err) self.message =  '<strong>There was a problem!:</strong> ' + err.message
                    // If you get a transactionHash, you can assume it was sent,
                    // or if you want to guarantee it was received, you can poll
                    // for that transaction to be mined first.
                    self.message = '<srong>Thanks for the generosity!!</strong> you can check transaction <a href="' + self.scanNetwork(transactionHash) + '" >Here</a>'
                })
            } else {
                this.message = "you Must install Metamask or, on mobile Trust Wallet"
            }
        },
        scanNetwork(tx) {
            let etherscanUrl = ""
            if (this.networkName == "MainNet") etherscanUrl = "https://etherscan.io/tx/"  + tx
            if (this.networkName == "Rinkeby") etherscanUrl = "https://rinkeby.etherscan.io/tx/"  + tx
            if (this.networkName == "Ropsten") etherscanUrl = "https://ropsten.etherscan.io/tx/"  + tx
            return etherscanUrl
        },
        allBalance() {
            this.amount = this.balance
        }
    }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css?family=Inconsolata');
.container{
    color: #FFF;
    font-family: "Roboto", sans-serif;
    overflow: hidden;
    z-index: 10;
    position: relative;
    margin: 40px auto;
    margin-top: 0px;
    height: 270px;
    width: 430px;
    /* background-color: #F17022; */
    border-radius: 12px;
}
.card {
    /* Add shadows to create the "card" effect */
    box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.37);
    transition: 0.3s;
  }
  
  /* On mouse-over, add a deeper shadow */
  .card:hover {
    box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.562);
  }
/*  BACKGROUND  */

.Circle1{
    z-index: 100;
    position: absolute;
    height: 80px;
    width: 80px;
    right: -20px;
    top: -30px;
    border-radius: 50%;
    /* background-color: rgba(253,184,19,1); */
    animation: enlarge;
    animation-duration: 5s;
    animation-iteration-count: infinite;
}

.Circle2{
    z-index: 80;
    position: absolute;
    height: 150px;
    width: 150px;
    right: -50px;
    top: -70px;
    border-radius: 50%;
    /* background-color: rgba(246,140,31,0.7); */
    animation: enlarge;
    animation-duration: 7s;
    animation-iteration-count: infinite;
}

.Circle3{
    z-index: 50;
    position: absolute;
    height: 200px;
    width: 200px;
    right: -50px;
    top: -100px;
    border-radius: 50%;
    /* background-color: rgba(241,125,45,0.7); */
    animation: enlarge;
    animation-duration: 10s;
    animation-iteration-count: infinite;
}

.logo{
    z-index: 1000;
    position: absolute;
    font-weight: 100;
    font-size: 20px;
    left: 50px;  
    top: 20px;
    width: 20px;
}

.brand{
    z-index: 1000;
    position: absolute;
    font-size: 20px;
    left: 120px;  
    top: 70px;
    font-weight: bold;
}

.addr {
    font-family: "Inconsolata", sans-serif;
    z-index: 1000;
    font-weight: bold;
    color: #ffee97;
    position: absolute;
    font-weight: 100;
    font-size: 27px;
    left: 50px;  
    top: 80px;    
}

.name {
    z-index: 1000;
    position: absolute;
    font-weight: 100;
    font-size: 18px;
    left: 50px;  
    top: 140px;    
}

.amount{
    z-index: 1000;
    position: absolute;
    font-size: 35px;
    font-weight: 400;
    left: 50px;
    bottom: 10px;
}

.balance {
    z-index: 1000;
    position: absolute;
    font-weight: 100;
    font-size: 11px;
    left: 55px;  
    bottom: 18px;    
}

.all-balance {
    z-index: 1000;
    position: absolute;
    font-weight: 100;
    font-size: 14px;
    left: 130px;  
    bottom: 58px;    
}

.currency{
    z-index: 1000;
    font-weight: 100;
    font-size: 16px;
    margin-left: 10px;
}


.network{
    color: #ffffff;
    font-weight: bold;
    z-index: 1000;
    position: absolute;
    font-size: 14px;
    font-weight: 200;
    right: 20px;
    top: 10px;
    padding: 2px 6px 2px 6px;
    background-color: rgb(89, 0, 255);
    border-radius: 6px;
}

.pay{
    z-index: 1000;
    position: absolute;
    font-size: 12px;
    font-weight: 200;
    right: 50px;
    bottom: 35px;
}

@keyframes enlarge{
    50%{
        transform: scale(1.2);
    }
}

.tip-button {
    width: 150px;
    height: 40px;
    background-size: 100%;
    background-image: url('../assets/ether3_off.png');
    cursor: pointer;
    border: none;
    border-radius: 3px;
  }
  
  .tip-button:hover {
    background-image: url('../assets/ether3_over.png');
  }
  
  .tip-button:active {
    background-image: url('../assets/ether3_off.png');
  }
  input[type=number] {
    width: 124px;
    padding: 10px 10px;
    font-size: 16px;
    box-sizing: border-box;
    border: 1px solid rgba(255, 102, 0, 0.63);
    border-radius: 5px;
    -webkit-transition: width 0.5s ease-in-out;
    transition: width 0.5s ease-in-out;
    background-color: rgba(255, 238, 87, 0.383);
    outline: none;
}
input[type=number]:focus {
    background-color: #eee;
    color: rgb(192, 77, 0);
    border: 2px solid rgba(209, 89, 9, 0.7);
}
.message{
    z-index: 1000;
    color: rgb(31, 31, 31);
    position: absolute;
    font-family: "Roboto", sans-serif;
    font-weight: 100;
    font-size: 14px;
    width: 430px;
}
</style>
